
import { WelcomeHero } from "@/components/WelcomeHero";
import { RecipeTransformationSection } from "@/components/RecipeTransformationSection";
import { useSubscription } from "@/hooks/use-subscription";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const Index = () => {
  const { user, subscriptionStatus, loadSubscriptionStatus, forceRefresh, isLoading } = useSubscription();
  const location = useLocation();
  
  useEffect(() => {
    // Check for success parameter in URL
    const params = new URLSearchParams(location.search);
    if (params.get('success') === 'true' && user) {
      console.log('Detected success parameter, triggering refresh');
      forceRefresh();
    }
  }, [location, user, forceRefresh]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFE29F] via-[#FFA99F] to-[#FF719A] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <motion.div
          className="absolute top-10 left-10 w-32 h-32 bg-white opacity-20 rounded-full"
          animate={{
            y: [0, 10, 0],
            scale: [1, 1.05, 1],
          }}
          transition={{
            duration: 5,
            repeat: Infinity,
            repeatType: "reverse",
          }}
        />
        <motion.div
          className="absolute top-40 right-20 w-20 h-20 bg-white opacity-10 rounded-full"
          animate={{
            y: [0, -15, 0],
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 7,
            repeat: Infinity,
            repeatType: "reverse",
          }}
        />
        <motion.div
          className="absolute bottom-20 right-40 w-40 h-40 bg-white opacity-15 rounded-full"
          animate={{
            y: [0, 20, 0],
            x: [0, -10, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            repeatType: "reverse",
          }}
        />
      </div>

      <div className="container mx-auto px-4 py-6 sm:px-6 sm:py-10 space-y-8 sm:space-y-16 relative z-10">
        <WelcomeHero />
        <RecipeTransformationSection 
          user={user}
          subscriptionStatus={subscriptionStatus}
          onLoadSubscriptionStatus={loadSubscriptionStatus}
          forceRefresh={forceRefresh}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default Index;
